module.exports = __webpack_public_path__ + "static/media/nametag.9ff89a7e.svg";